import axios from "axios";

const state = {
    domains: [],
	domain: {}
};

const actions = {
	
    async loadDomains(context){
        return axios.get("/api/opensrs/list/domains").then(function(response){
            console.log(response)
			context.commit("setDomains", response.data);
        })
    },

	async loadDomain(context,domain){
		return axios.get("/api/opensrs/domain",{params:{domain:domain}}).then(function(response){
            console.log(response)
			context.commit("setDomain", response.data);
        })
	},

	async loadDomainBilling(context,payment_id){
		return axios.get("/api/recurring/billing",{params:{payment_id:payment_id}}).then(function(response){
            console.log(response)
			context.commit("setDomain", response.data);
        })
	}

}

const mutations = {
    setDomains(state,data){
        state.domains = data;
    },

	setDomain(state,data){
        state.domain = data;
    },



}

const getters = {
    domains(state){
        return state.domains;
    },

	domain(state){
        return state.domain;
    },


};
  
export default {
    state,
    actions,
    mutations,
    getters
};